/**
 * Small predicate helpers shared by the action modal's sub-tabs.
 *
 * Kept in a non-component module so react-refresh doesn't complain
 * about a component file re-exporting utilities (see
 * `react-refresh/only-export-components`).
 */

import type { PredicateNode } from '@/admin/components/condition-builder/types'

export function normalisePredicate(
  raw: PredicateNode | Record<string, never> | null | undefined,
): PredicateNode | null {
  if (!raw || typeof raw !== 'object') return null
  const node = raw as PredicateNode
  if (node.type === 'clause' || node.type === 'group') return node
  return null
}
